import React from 'react';
import { connect } from 'react-redux';
import { Form, Select, Input, Radio, Button } from 'antd';
import Preloader from '../../Preloader/Preloader';
import PrimaryFormWrapper from './PrimaryForm.style';
import { setSelectedValues, updateStep, getFilterList, getSecTabs, getConfigList } from '../../../redux/actions/IC/ICActions';

const FormItem = Form.Item;
const Option = Select.Option;
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

class AddPrimaryConfig extends React.Component {
  
  constructor() {
    super();
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.props.getConfigList();
    this.props.getFilterList();
    this.props.getSecTabs();
  }

  handleSubmit = (e) => {
    let that = this;
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        let ic_config = this.props.ICREDUCER.selectedValues;
        Object.keys(values).map(value => ic_config[value] = values[value]);
        that.props.setSelectedValues(ic_config);
        that.props.updateStep(2);
      }
    });
  }
  
  render() {

    if(this.props.APPREDUCER.showPreloader === true) {
      return(
        <Preloader />
      )
    }
    else {
      
      const { getFieldDecorator } = this.props.form;
      const formItemLayout = {
        labelCol: { span: 6 },
        wrapperCol: { span: 12 },
      };

      const filters = this.props.ICREDUCER.config_1.filters.map((filter,i) => <Option key={i} value={filter.name}>{filter.name.split("")[0].toUpperCase()+filter.name.split("").slice(1).join("")}</Option>);
      const sec_tabs = this.props.ICREDUCER.config_1.secondary_tabs.map((tab,i) => <Option key={i} value={tab.name}>{tab.name}</Option>);
      const type_values = this.props.ICREDUCER.config_1.type.map((type,i) => <Option key={i} value={type}>{type}</Option>);
      const currencies = this.props.ICREDUCER.config_1.currencies.map((curr,i) => <Option key={i} value={curr}>{curr}</Option>);

      const custom_rules = this.props.from === 'add'
      ?
      [
        { 
          required: true,
          message: 'Please Enter IC Code!'
        },
        {
          validator: (rule, value, cb) => ( this.props.ICREDUCER.configList.filter( val => val.ic_code === value ).length > 0 ? cb(true) : cb() ), 
          message: 'IC Code already exists!'
        }
      ]
      :
      [
        { 
          required: true,
          message: 'Please Enter IC Code!'
        }
      ];

      return(
        <PrimaryFormWrapper>
        
          <Form onSubmit={this.handleSubmit}>
            <FormItem
              {...formItemLayout}
              label="IC Name"
              hasFeedback>
              {getFieldDecorator('name', {
                initialValue: this.props.ICREDUCER.selectedValues.name,
                rules: [
                  { required: true, message: 'Please enter IC Name!' },
                ],
              })(
                <Input type="text" placeholder="Enter IC Name" />
              )}
            </FormItem>
            <FormItem
              {...formItemLayout}
              label="IC Code"
              hasFeedback>
              {getFieldDecorator('ic_code', {
                initialValue: this.props.ICREDUCER.selectedValues.ic_code,
                rules: custom_rules,
              })(
                <Input type="text" disabled={this.props.from === 'add' ? false : true } placeholder="Enter IC Code" />
              )}
            </FormItem>
  
            <FormItem
              {...formItemLayout}
              label="Analysis"
            >
              {getFieldDecorator('analysis', {
                initialValue: this.props.ICREDUCER.selectedValues.analysis === null ? false : this.props.ICREDUCER.selectedValues.analysis,
                rules: [
                  { required: true, message: 'Please Select a value for Analysis!' },
                ],
              })(
                <RadioGroup>
                  <RadioButton value={true}>Yes</RadioButton>
                  <RadioButton value={false}>No</RadioButton>
                </RadioGroup>
              )}
            </FormItem>
  
            <FormItem
              {...formItemLayout}
              label="Filters"
            >
              {getFieldDecorator('filters', {
                initialValue: this.props.ICREDUCER.selectedValues.filters,
                rules: [
                  { required: true, message: 'Please select your filters!', type: 'array' },
                ],
              })(
                <Select showSearch mode="multiple" placeholder="Select list of filters">
                  {filters}
                </Select>
              )}
            </FormItem>
  
            <FormItem
              {...formItemLayout}
              label="Secondary Tabs"
            >
              {getFieldDecorator('secondary_tabs', {
                initialValue: this.props.ICREDUCER.selectedValues.secondary_tabs, 
                rules: [
                  { required: true, message: 'Please select your tabs!', type: 'array' },
                ],
              })(
                <Select showSearch mode="multiple" placeholder="Select list of tabs">
                  {sec_tabs}
                </Select>
              )}
            </FormItem>
  
            <FormItem
              {...formItemLayout}
              label="Type"
            >
              {getFieldDecorator('type', {
                initialValue: this.props.ICREDUCER.selectedValues.type,
                rules: [
                  { required: true, message: 'Please select your type!', type: 'array' },
                ],
              })(
                <Select showSearch mode="multiple" placeholder="Select list of types">
                  {type_values}
                </Select>
              )}
            </FormItem>
  
            <FormItem
              {...formItemLayout}
              label="Base Currency"
            >
              {getFieldDecorator('base_currency', {
                initialValue: this.props.ICREDUCER.selectedValues.base_currency,
                rules: [
                  { required: true, message: 'Please select your base currency!', type: 'string' },
                ],
              })(
                <Select placeholder="Select base currency">
                  {currencies}
                </Select>
              )}
            </FormItem>
  
            <FormItem
              wrapperCol={{ span: 12, offset: 6 }}
            >
              <Button type="primary" htmlType="submit">Proceed</Button>
            </FormItem>
          </Form>
  
        </PrimaryFormWrapper>
      )
    }
  }
}

function mapStateToProps(state) {
  return state;
}

const mapDispatchToProps = {
  setSelectedValues,
  updateStep,
  getFilterList,
  getSecTabs,
  getConfigList
}

const PrimaryForm = Form.create()(AddPrimaryConfig);

export default connect(mapStateToProps, mapDispatchToProps)(PrimaryForm);


// WEBPACK FOOTER //
// ./src/components/IC/PrimaryForm/PrimaryForm.js